import axios from "axios";
import Cookies from "js-cookie";
import { store } from "../Store/store";
import { setTokenErr } from "../Store/Common/commonStore";

const DEFAULT_CONFIG = {
  headers: {
    "content-type": "application/json",
  },
};

const setUpConfig = (isAuthenticated, token = "", fileDownload, fileUpload) => {
  if (isAuthenticated) {
    const authHeader = {
      Authorization: token !== "" ? token : fileUpload ? "" : Cookies.get("ssp_sso_token"),
    };
     if (fileDownload) {
      return {
        responseType: "blob",
        headers: {
          ...(fileUpload
            ? { "content-type": "multipart/form-data" } // different header for POST download
            : { "content-type": "application/json" }),
          ...authHeader,
        },
      };
    }
    // default config when authenticated, no file download
    return {
      headers: {
        "content-type": "application/json",
        ...authHeader,
      },
    };
  } else {
    return DEFAULT_CONFIG;
  }
};

const getData = async (url, isAuthenticated = false, fileDownload = false, fileUpload = false) => {
  store.dispatch(setTokenErr(false));
  try {
    const CONFIG = setUpConfig(isAuthenticated, "", fileDownload, fileUpload);
    const response = await axios.get(url, CONFIG);
    return response;
  } catch (error) {
    console.log(error.message);
    store.dispatch(setTokenErr(true));
    return {
      data: {
        message: "Error While hitting the Api",
        status: "failure",
        data: [],
      },
    };
  }
};

const postData = async (
  url,
  isAuthenticated = false,
  fileDownload = false,
  payload,
  fileUpload = false,
) => {
  store.dispatch(setTokenErr(false));
  const CONFIG = setUpConfig(isAuthenticated, "", fileDownload, fileUpload);

  try {
    const response = await axios.post(url, payload, CONFIG);
    return response;
  } catch (error) {
    store.dispatch(setTokenErr(true));
    console.log(error.message);
    return {
      data: {
        message: "Error While hitting the Api",
        status: "failure",
        data: [],
      },
    };
  }
};

const xlsxConvertFunc = async (data, fileName) => {
  try {
    let rawString = "";

    // 1. If Axios wrapped our response in a Blob, extract the text from it
    if (data instanceof Blob) {
      rawString = await data.text();
    } 
    // Fallback just in case it's a normal object or string
    else if (typeof data === 'object') {
      rawString = data.body || data.data || JSON.stringify(data);
    } else {
      rawString = String(data);
    }

    // 2. Clean the string
    let cleanData = rawString.replace(/^"|"$/g, '').trim().replace(/\s/g, '');
    if (cleanData.includes('base64,')) {
      cleanData = cleanData.split('base64,')[1];
    }

    // Fix missing padding
    while (cleanData.length % 4 !== 0) {
      cleanData += '=';
    }

    // 3. Decode the base64 string
    const byteCharacters = atob(cleanData);
    
    // 4. Create an array of byte values
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    
    // 5. Convert to a typed byte array
    const byteArray = new Uint8Array(byteNumbers);

    // 6. Create the final binary Blob for the Excel file
    const url = window.URL.createObjectURL(
      new Blob([byteArray], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      })
    );
    
    // 7. Trigger the download
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    
    // 8. Clean up safely
    setTimeout(() => {
      link.remove();
      window.URL.revokeObjectURL(url);
    }, 150);

  } catch (err) {
    console.error("TransactionLayout.xlsxConvertFunc Error: ", err);
  }
};
export { getData, postData, xlsxConvertFunc };
